import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSiteAdminControlsLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSiteAdminControls" */ './components/ShareableLinkSiteAdminControls.tsx'
			)
		).ShareableLinkSiteAdminControls,
});
